import SideMenu from './side-menu.vue'
export default SideMenu



// WEBPACK FOOTER //
// ./src/view/main/components/side-menu/index.js